/**
 * toastHandler
 *
 * The toastHandler provides methods for opening success / error toasts.
 */

export default function toastHandler () {
  return {
    methods: {
      delayToastAction (action, message = null) {
        if (window.$vue3?.toasts) {
          window.$vue3?.toasts[action](message)
        } else {
          window.setTimeout(() => {
            this.delayToastAction(action, message)
          }, 500)
        }
      },
      clearToasts () {
        if (window.$vue3?.toasts) {
          window.$vue3.toasts.clearToasts()
        } else {
          window.setTimeout(() => {
            this.delayToastAction('clearToasts')
          }, 500)
        }
      },
      successToast (message, onCloseCb) {
        if (window.$vue3?.toasts) {
          window.$vue3.toasts.successToast(message, onCloseCb)
        } else {
          window.setTimeout(() => {
            this.delayToastAction('successToast', message)
          }, 500)
        }
      },
      errorToast (message, onCloseCb) {
        if (window.$vue3?.toasts) {
          window.$vue3.toasts.errorToast(message, onCloseCb)
        } else {
          window.setTimeout(() => {
            this.delayToastAction('errorToast', message)
          }, 500)
        }
      }
    }
  }
}
